<template>
    <div>
        <div class="Profile__avatar">
            <img :src="profile.large_avatar" :alt="profile.name" class="ProfilePicture__img" :draggable="false"/>
            <button @click.prevent="handleClick" type="button" class="Profile__avatar-edit">
                <i class="fas fa-pen"></i>
            </button>
        </div>
    </div>
</template>

<script>
    import ModalBus from "../eventBus";
    import AvatarEditorModal from "./Modals/Account/AvatarEditorModal";

    export default {
        data: function () {
            return {
                open: false
            }
        },
        computed: {
            profile: function () {
                return this.$user.profile;
            }
        },
        methods: {
            handleClick: function () {
                ModalBus.open({component: AvatarEditorModal})
            }
        }
    }
</script>
